/** @jsxImportSource @emotion/react */
import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import UDNavLink, { type IUDNavLinkProps } from 'ud-ui/components/link/nav-link';

interface IAllTournamentButtonProps extends Omit<IUDNavLinkProps, 'to'> {}

function AllTournamentButton(props: IAllTournamentButtonProps) {
  return (
    <UDNavLink
      {...props}
      to={Pages.CHAMPIONSHIPS.INDEX}
      variant={props.variant ?? 'primary'}
      className={classNames('text caption-1 fw-700 ml-2', props.className)}
      style={{ transition: 'color 0.2s ease', ...props.style }}
    >
      <Trans>Все турниры</Trans>
    </UDNavLink>
  );
}

export default AllTournamentButton;
